// extracted by mini-css-extract-plugin
export var center = "_3y-2";
export var clickableRow = "_3y-5";
export var expandedRow = "_3y-7";
export var hoverable = "_3y-4";
export var left = "_3y-1";
export var right = "_3y-3";
export var row = "_3y-0";
export var selectedRow = "_3y-6";
export var summaryRow = "_3y-8";